import { useNumInstances } from '../context/instance/instanceContext';
import { useAppSelector } from '../redux/store';
export function useIsRowLayoutMode() {
    const isColumnLayoutMode = useAppSelector((state) => state.common.isColumnLayoutMode);
    const numInstances = useNumInstances();
    if (numInstances > 1) {
        // in local environment with more than one game instance, always show in row layout
        return true;
    }
    return !isColumnLayoutMode;
}
